import { Box, makeStyles, Typography, Link } from "@material-ui/core";
import React from "react";
import { useQuery, useState, useEffect } from "react";
import moment from "moment";
import { getTableData, getGraphqlData } from "../../redux/actions/web3Actions";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../Modals/CustomModal";
import ProjectBriefModal from "../Modals/ProjectBriefModal.js";

const useStyles = makeStyles((theme) => ({
  table: {
    border: "1px solid pink",
    // height: "10rem",
    marginTop: "1rem",
    // height:"auto"
  },
  Card3: {
    width: "100%",
    backgroundColor: "white",
    padding: "2.5rem",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    // height: "30rem",
    margin: "3rem 0px",
  },
  dot: {
    backgroundColor: ({ color }) => color,
    height: "6px",
    width: "6px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2rem",
    lineHeight: "3rem",
    // marginBottom: "4rem",
    marginLeft: "1rem",
  },
  head: {
    height: "4rem",
    backgroundColor: "rgba(246, 48, 169, 0.1)",
    display: "flex",
    // justifyContent: "space-around",
    alignItems: "center",
    textAlign: "center",
  },
  body: {
    display: "flex",
    flexDirection: "column",

    textAlign: "center",
  },
  headingText: {
    fontWeight: "600",
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyText: {
    // fontWeight: "600",
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyTextPink: {
    // fontWeight: "600",
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#f630A9",
    textDecoration: "underline",
  },
  dot: {
    backgroundColor: ({ color }) => color,

    height: "5px",
    width: "5px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },

  row: {
    display: "flex",
    height: "4.3rem",
    alignContent: "center",
    borderBottom: "1px solid rgba(246, 48, 169, 0.2)",
    // backgroundColor: "aqua",
  },
  statusText: {
    borderRadius: "12px",
    backgroundColor: ({ bgcolor }) => bgcolor,
    padding: "3px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonBox: {
    fontWeight: "600",
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    borderRadius: "4px",
    border: "1px solid #f630A9",
    padding: "0.6rem 1.5rem",
    color: "#f630A9",
    fontWeight: "700",
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const Dot = (color) => {
  console.log("color", color);
  const classes = useStyles(color);
  const isUser = useSelector((state) => state.ui.isUser);
  console.log("claimableId by kol ========", isUser.kol);

  return <Box className={classes.dot}></Box>;
};
const StatusBox = ({ d, bgcolor }) => {
  // console.log("dddddddd", bgcolor, d);
  const classes = useStyles({ bgcolor });
  return (
    <Box className={classes.statusText}>
      <Dot color={d?.status == "Complete" ? "#1ED059" : "#0843F5"} />
      <Typography>{d?.status}</Typography>
    </Box>
  );
};

const LineTable = ({ title, heading, kol, filteredGraphData }) => {
  const isUser = useSelector((state) => state.ui.isUser);
  console.log("claimableId by kol ========", isUser.kol);
  console.log("Blah ========", filteredGraphData);

  const allCampaignData = useSelector((state) => state.ui.allCampaignData);
  console.log("allCampaignData inside MODAL ===> ", allCampaignData);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState();

  const classes = useStyles();
  const [data, setData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTableData(isUser?.kol?._id));
  }, [isUser]);

  const tableData = useSelector((state) => state.ui.tableData);
  console.log("tabledata redux ===> ", tableData);

  useEffect(() => {
    if (tableData) {
      setData(
        tableData?.map((t) => {
          return {
            months: moment(parseInt(t.timestamp)).format("MMMM"),
            // NoOfProj: tableData.length,
            invested: t.invested,
            workOutstanding: t.workOutstanding,
            tokenAmount: t.tokenAmount,
            tokenOutstanding: t.tokenOutstanding,
          };
        })
      );
    }
  }, [tableData]);

  useEffect(() => {
    console.log("line table", filteredGraphData);
    if (filteredGraphData) {
      setGraphData(
        filteredGraphData[0]?.map((t) => {
          return {
            postOutstanding: t.postOutstanding,
            dateToComplete: t.dateToComplete,
            status: t.status,
            url: t.url ? t.url : null,
            projectBrief: "project",
            data: {
              campaignName: t.projectBrief?.campaignName,
              projectName: t.projectBrief?.projectName,
              keyword: t.projectBrief?.keyword,
            },
          };
        })
      );
    }
  }, [filteredGraphData]);

  // console.log("SARAH GRAPH", filteredGraphData);

  return (
    <Box className={classes.Card3}>
      <Typography className={classes.pageHeading}>{title}</Typography>
      <Box className={classes.table}>
        <Box className={classes.head}>
          {heading?.map((h) => {
            return <Typography className={classes.headingText}>{h}</Typography>;
          })}
        </Box>
        {kol ? (
          <Box className={classes.body}>
            {graphData?.map((d) => {
              return (
                <Box className={classes.row}>
                  <Typography className={classes.bodyText}>
                    {d.postOutstanding}
                  </Typography>
                  <Typography className={classes.bodyText}>
                    {d.dateToComplete.slice(0, 10)}
                  </Typography>
                  <Box className={classes.bodyText}>
                    <StatusBox
                      d={d}
                      bgcolor={d.status == "Complete" ? "#B2F2C6" : "#ECF1FF"}
                    />
                  </Box>
                  <Link href={d.url} className={classes.bodyTextPink}>
                    {d.url ? "Twitter url" : null}
                  </Link>
                  <Typography
                    onClick={() => {
                      setModalData(d.data);
                      setShowModal(true);
                    }}
                    className={classes.bodyTextPink}
                  >
                    project
                  </Typography>

                  <ProjectBriefModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    modalData={modalData}
                  />
                </Box>
              );
            })}
          </Box>
        ) : (
          <Box className={classes.body}>
            {data.map((d) => {
              return (
                <Box className={classes.row}>
                  <Typography className={classes.bodyText}>
                    {d.months}
                  </Typography>
                  {/* <Typography className={classes.bodyText}>
                    {d.NoOfProj}
                  </Typography> */}
                  <Typography className={classes.bodyText}>
                    {d.invested}
                  </Typography>
                  <Typography className={classes.bodyText}>
                    {d.workOutstanding}
                  </Typography>
                  <Typography className={classes.bodyText}>
                    {parseInt(d.invested / d.tokenAmount)}
                  </Typography>
                  <Typography className={classes.bodyText}>
                    {d.tokenOutstanding}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LineTable;
